export enum HTTPStatusEnum {
  OK = 200,
  BAD_REQUEST = 400,
  FORBIDDEN = 403,
  CONFLICT = 409,
  BAD_REQUEST_DATA = 420,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500
}

export type LogSeverity = 'error' | 'warning';

export interface LogModel {
  id?: string;
  module: string;
  error?: string;
  errorStack: string;
  errorCode?: string;
  errorProvider?: string;
  errorSource?: string;
  pageKey?: string;
  job_id: string | number;
  status: string;
  user: string;
  bookId: string | number;
  bookTitle: string;
  timestamp: number;
  failedPrompt?: string | null;
  // Defaults to 'error' for legacy records (server returns the field
  // explicitly on new records, undefined on old ones).
  severity?: LogSeverity;
  // Only set on warning records: the rewritten prompt actually sent to
  // the image provider after softening.
  softenedPrompt?: string | null;
}